// fix for search button
document.addEventListener('DOMContentLoaded', () => {
    const searchBtn = document.querySelector('a.cart.nav-search[data-modal-toggle]');
    if (searchBtn) {
      searchBtn.addEventListener('keydown', (e) => {
        if (e.key === ' ') {
          e.preventDefault();
          searchBtn.click();
        }
      });
    }
  });

// fix for opening mega menu
document.addEventListener('DOMContentLoaded', function () {

  const triggers = document.querySelectorAll(
    '.contains-mega-menu > a.has-children'
  );

  triggers.forEach(trigger => {

    trigger.addEventListener('keydown', function(e) {

      // ENTER opens submenu
      if (e.key === 'Enter') {

        trigger.dataset.submenuOpen = 'true';
      }

      // FIRST TAB after open
      else if (
        e.key === 'Tab' &&
        trigger.dataset.submenuOpen === 'true'
      ) {

        e.preventDefault();

        const parent = trigger.closest('.contains-mega-menu');
        if (!parent) return;

        const submenu = parent.querySelector('.nav-columns');
        if (!submenu) return;

        // Wait for menu to be visible before focusing
        setTimeout(() => {
          const firstLink = submenu.querySelector('a');
          if (firstLink) {
            firstLink.focus();
          }
        }, 150);

        trigger.dataset.submenuOpen = 'false';
      }


    });

  });

});

  // This "Observer" stays awake and watches for the app to inject the overlay (for ADA compliance)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      var scOverlay = document.querySelector('.slidecarthq-overlay');
      if (scOverlay && !scOverlay.getAttribute('aria-label')) {
        scOverlay.setAttribute('aria-label', 'Close cart');
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // This watches for the pop-up and adds the missing label
var popupObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // Look for common pop-up classes like 'klaviyo-form' or 'privy-popup'
    // Or the generic 'role=dialog' flagged in your report
    var dialog = document.querySelector('[role="dialog"]');
    if (dialog && !dialog.getAttribute('aria-label')) {
      dialog.setAttribute('aria-label', 'Newsletter Subscription');
    }
  });
});

popupObserver.observe(document.body, { childList: true, subtree: true });


// Klaviyo ADA Compliance code
  const isAriaHiddenTrue = ($el) => {
    const ariaHiddenValue = $el ? $el.getAttribute("aria-hidden") : null;
    return ariaHiddenValue === "true";
  };

  const isHTMLElement = (node) => {
    return node.nodeType === Node.ELEMENT_NODE;
  };

  const isModal = (node) => {
    if (node.children.length !== 1) return false;
    const modalContainer = Array.from(node.children[0].classList).some((cls) =>
      cls.startsWith("kl-private-reset")
    );

    return modalContainer;
  };

  const getTopLevelDomElements = () => {
    const body = document.body;

    // Use the children property to get all top-level elements
    const topLevelNodes = Array.from(body.children).filter((node) => {
      if (isHTMLElement(node)) {
        const tagName = node.tagName.toLowerCase();

        console.log("isModal: ", isModal);

        // Filter out specific tags
        return (
          tagName !== "script" &&
          tagName !== "link" &&
          tagName !== "iframe" &&
          tagName !== "style" &&
          !isModal(node)
        );
      }
      return false;
    });

    return topLevelNodes;
  };

  const a11yHideTopLevelElements = () => {
    const $elements = getTopLevelDomElements();

    $elements.forEach(($el) => {
      if (!isAriaHiddenTrue($el)) {
        $el.setAttribute("kl-aria-hidden", "true");
        $el.setAttribute("aria-hidden", "true");
      }
    });
  };

  const a11yShowTopLevelElements = () => {
    const $elements = getTopLevelDomElements();

    $elements.forEach(($el) => {
      if ($el.hasAttribute("kl-aria-hidden")) {
        $el.removeAttribute("kl-aria-hidden");
        $el.removeAttribute("aria-hidden");
      }
    });
  }; 
window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
    a11yHideTopLevelElements(); // Hides background
  }
  if (e.detail.type == 'close') {
    a11yShowTopLevelElements(); // Shows background again
  }
});

// Filter checkboxes - Enter key selection + focus ring
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cc-checkbox__input').forEach(input => {

    // Enter key to select
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Focus ring visibility
    input.addEventListener('focus', () => {
      input.parentElement.querySelector('.cc-checkbox__label').style.outline = '3px solid #005fcc';
      input.parentElement.querySelector('.cc-checkbox__label').style.outlineOffset = '2px';
      input.parentElement.querySelector('.cc-checkbox__label').style.borderRadius = '4px';
    });
    input.addEventListener('blur', () => {
      input.parentElement.querySelector('.cc-checkbox__label').style.outline = '';
      input.parentElement.querySelector('.cc-checkbox__label').style.outlineOffset = '';
      input.parentElement.querySelector('.cc-checkbox__label').style.borderRadius = '';
    });

  });
});

// Mega menu submenu links - Enter key navigation
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nav-columns a').forEach(link => {
    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        window.location.href = link.href;
      }
    });
  });
});

// clickable mega menu submenu headers with tab
/**
 * ADA Keyboard Accessibility - Mega Menu
 * Allows keyboard users to open submenu dropdowns using Enter or Space,
 * then moves focus to the first link inside the submenu.
 */
document.addEventListener('DOMContentLoaded', function () {

  // Select all top-level nav items that have a submenu
  const menuItems = document.querySelectorAll('.tier-1 li.contains-children.contains-mega-menu');

  menuItems.forEach(function (item) {

    // Find the trigger link (the top-level nav label e.g. "Men", "Women")
    const trigger = item.querySelector('a.has-children[aria-haspopup="true"]');
    if (!trigger) return;

    trigger.addEventListener('keydown', function (e) {

      // Only intercept Enter and Space keys
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Prevent link navigation and page scroll

        const isOpen = item.classList.contains('is-focused');

        // Close all open submenus and reset aria-expanded
        menuItems.forEach(function (i) {
          i.classList.remove('is-focused');
          const t = i.querySelector('a.has-children[aria-haspopup="true"]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        // If this item wasn't already open, open it
        if (!isOpen) {
          item.classList.add('is-focused');
          trigger.setAttribute('aria-expanded', 'true');

          // Move focus to the first link inside the submenu
          const firstLink = item.querySelector('.nav-rows a');
          if (firstLink) firstLink.focus();
        }
      }
    });
  });
});

